<div id="content" class="allcp-form" ng-controller="WorkerController" ng-init="init()">
    <div ng-include="'modules/company/menus/user_menu.html'"></div>
    <div ng-include="'modules/company/workers/modal.html'"></div>

    <div class="navbar fixed-panel-footer" ng-if="deleted.length">
        <div class="nav navbar-nav navbar-left">
            <a href="#" ng-click="selectAll(true)" class="btn mr-2 btn-outline">Select All</a>
            <a href="#" ng-click="selectAll(false)" class="btn btn-outline">Unselect</a>
        </div>
        <div class="nav navbar-nav navbar-center">
        </div>
        <div class="nav navbar-nav navbar-right">
            <a href="#" 
                class="hod-button blue mr-2" 
                ng-click="sendNotification('set')" 
                ng-if="deleted.length > 0">Send Push Notification
            </a>

            <a href="#" 
                class="btn btn-danger btn-rounded mr-3"
                ng-click="delete('set')" 
                ng-disabled="deleted.length == 0" 
                ng-if="deleted.length > 0"> Delete
            </a>
        </div>
    </div>
    <div ng-include="'modules/company/workers/edit.html'"></div>

    <div class="panel-body">
        <div class="table-responsive" ng-if="data.workers.data.length > 0">
            <table class="table table-hover tc-checkbox-1 fs13">
                <thead class="p20">
                    <tr class="bg-light">
                        <th class="text-center w75"></th>
                        <th>Full Name</th>
                        <th>Phone Number</th>
                        <th>Device</th>
                        <th>
                            <a href="#" ng-click="sortType = 'app_version'; sortReverse = !sortReverse">
                                App Version
                                <span ng-show="(sortType == 'app_version' && !sortReverse ) || true" class="fa fa-sort-alpha-desc"></span>
                                <span ng-show="sortType == 'app_version' && sortReverse" class="fa fa-sort-alpha-asc"></span>
                            </a>
                        </th>
                        <!-- <th>
									Ekip
								</th> -->
                        <th>Vehicle</th>
                        <th>Dispatcher</th>
                        <th>Status</th>
                        <th></th>
                    </tr>
                </thead>
                <tbody>
                    <tr class="text-left" ng-repeat="item in data.workers.data | filter: data.term | orderBy:sortType:sortReverse ">
                        <td>
                            <label class="option block mn">
                                <input type="checkbox" name="deleted[]" ng-checked="deleted.indexOf(item.id) > -1" ng-click="toggleSelection(item.id)">
                                <span class="checkbox mn"></span>
                            </label>
                        </td>
                        <td class="clickable-row" ng-click="getWorkerDetails(item.id)">
                            <div class="avatar-container">
                                <div class="avatar-img">
                                    <img ng-src="https://s3.us-west-2.amazonaws.com/hodxpress/{{ item.profile_photo }}" class="img-responsive text-center img-circle" width="36px" height="36px" style="width:36px;  height:36px;" alt="">
                                </div>
                                <div class="avatar-detail">
                                    <strong style="font-weight:bold">{{item.user.full_name}}</strong>
                                    {{item.user.email}}
                                </div>
                            </div>
                        </td>
                        <td class="clickable-row" ng-click="getWorkerDetails(item.id)">{{ item.phone_number }}</td>
                        <td class="clickable-row" ng-click="getWorkerDetails(item.id)">{{ item.device }}</td>
                        <td class="clickable-row" ng-click="getWorkerDetails(item.id)">{{ item.app_version }}</td>
                        <!-- <td class="clickable-row" ng-click="getWorkerDetails(item.id)">{{ item.team.name }}</td> -->
                        <td class="clickable-row" ng-click="getWorkerDetails(item.id)">
                            {{ item.vehicle_make }} {{ item.vehicle_model }} {{ item.vehicle_year }}
                        </td>
                        <td class="clickable-row" ng-click="getWorkerDetails(item.id)">
                            {{ item.dispatcher ? 'Yes' : 'No' }}
                        </td>
                        <!-- <td ng-click="getWorkerDetails(item.id)">
                            <span class="label label-success" ng-if="item.status == 1">Online</span>
                            <span class="label label-success" ng-if="item.status == 0">Offline</span>
                        </td> -->
                        <td ng-click="getWorkerDetails(item.id)">
                            <span class="label label-danger" ng-if="item.user.status == 1">Waiting Approve</span>
                            <span class="label label-primary" ng-if="item.user.status == 0">Approved</span>
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
        <div class="table-responsive" ng-if="data.workers.data.length == 0">
            <div class="alert alert-default pastel">
                <i class="fa fa-info pr10"></i>
                <strong>
                    Driver not found!
                </strong>
            </div>
        </div>
    </div>
    <div ng-include="'modules/company/settings/partials/delete.html'"></div>

    <div class="modal fade" id="notification" tabindex="-1" role="dialog" aria-labelledby="notificationLabel">
        <div class="modal-dialog" role="document">
            <div class="modal-content">
                <div class="modal-header">
                    <button type="button" class="close" data-dismiss="modal" aria-label="Close"><span aria-hidden="true">&times;</span></button>
                    <h5 class="modal-title"> <strong> Send Push Notification!</strong></h5>
                </div>
                <div class="modal-body">
                    <div class="form-group">
                        <label for="title">Title</label>
                        <input type="text" name="title" ng-model="notification.title" class="form-control" placeholder="Başlık">
                    </div>
                    <div class="form-group">
                        <label for="description">Content</label>
                        <textarea name="description" ng-model="notification.description" class="form-control" placeholder="İçerik" cols="30" rows="5"></textarea>
                    </div>
                </div>
                <div class="modal-footer">
                    <button type="button" class="btn btn-default" data-dismiss="modal">Cancel</button>
                    <button type="button" class="btn btn-danger" ng-click="sendNotification('send',notification)" data-dismiss="modal">Send</button>
                </div>
            </div>
        </div>
    </div>
</div>